import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { MdEdit, MdDeleteForever } from "react-icons/md";
import Box from "@mui/material/Box";
import Popup from "reactjs-popup";
import { TextField } from "@mui/material";

const ChapterComponent = ({
  id,
  session,
  subject_name,
  subjectId,
  subjectList,
  onEditChapter,
  onDelete,
}) => {
  const [loading, setLoading] = useState(false);
  const [editingChapter, setEditingChapter] = useState(false);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [editedChapterDetails, setEditedChapterDetails] = useState({
    session: session,
    subject: subjectId,
  });
  const [errors, setErrors] = useState({
    session: "",
    subject: "",
  });
  const handleChapterChange = (event) => {
    const { name, value } = event.target;
    setEditedChapterDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", 
    }));
  };

  const handleSubmitEdit = (event, close) => {
    event.preventDefault();

    // Validation logic
    const newErrors = {};
    if (!editedChapterDetails.session) {
      newErrors.session = "Chapter Name is required";
    }
    if (!editedChapterDetails.subject) {
      newErrors.subject = "Subject is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; 
    }

    onEditChapter(id, editedChapterDetails, close);
    setEditingChapter(false);
  };


  const handleConfirmDelete = () => {
    onDelete(id);
    setDeleteConfirmationOpen(false);
  };

  return (
    <Card className="note-card">
      <Card.Body>
        <Card.Text className="note">
          <Row>
            <Col lg={4} className=" mt-lg-1">
              <div className="course-span">Chapter Name:</div>
            </Col>
            <Col lg={8}>
              <div className=" mt-lg-1">{session}</div>
            </Col>
            <Col lg={4} className=" mt-lg-2">
              <div className="course-span">Subject:</div>
            </Col>
            <Col lg={8}>
              <div className=" mt-lg-2">{subject_name}</div>
            </Col>
          </Row>
        </Card.Text>
        <div className="note-edit-delete">
          <Popup
            className="add-popup-container"
            trigger={
              <button className="course-edit">
                <MdEdit />
              </button>
            }
            modal
            nested
          >
            {(close) => (
              <div className="add-course-div">
                <form
                onSubmit={(e) => handleSubmitEdit(e, close)}
                >
                  <Box className="popup-box">
                    <div className="heading">Edit Chapter Details</div>
                    <div className="course-container">
                      <TextField
                        className="textfields"
                        name="session"
                        label="Chapter Name"
                        variant="outlined"
                        size="small"
                        value={editedChapterDetails.session}
                        onChange={handleChapterChange}
                        disabled={loading}
                        error={!!errors.session}
                        helperText={errors.session}
                      />
                      <select
                        name="subject"
                        className="form-control"
                        value={editedChapterDetails.subject}
                        onChange={handleChapterChange}
                        disabled={loading}
                      >
                        <option value="">Select Subject</option>
                        {subjectList.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      {errors.subject && <div className="error-text">{errors.subject}</div>}
                    </div>
                    <div className="submit-banner-button-container">
                      <button
                        type="submit"
                          disabled={loading}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        onClick={close}
                          disabled={loading}
                      >
                        Cancel
                      </button>
                    </div>
                  </Box>
                </form>
              </div>
            )}
          </Popup>
          <Popup
            className="popup-container"
            contentStyle={{
              borderRadius: "20px",
              backgroundColor: "white",
            }}
            trigger={
              <button className="course-delete">
                <MdDeleteForever />
              </button>
            }
            modal
            nested
          >
            {(close) => (
              <div className="delete-img-div">
                <h3 className="delete-img-heading">Are you sure?</h3>
                <p className="delete-img-p">Do you really want to delete?</p>
                <div className="delete-btn-div">
                  <button
                    onClick={handleConfirmDelete}
                  >
                    Delete
                  </button>
                  <button onClick={close}>Cancel</button>
                </div>
              </div>
            )}
          </Popup>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ChapterComponent;
